import React, {
  ForwardedRef,
  forwardRef,
  useEffect,
  useRef,
  useState
} from 'react';

import { events, messageBus } from '@schibsted-nmp/advertising-events';
import { LayoutType } from '@schibsted-nmp/advertising-shared';

import { useRecommendationIds } from '../hooks/useRecommendationIds';
import { injectRecircSlotInWebComponent } from '../utils/injectRecircSlot';

export interface Props {
  itemId: string;
  categories?: string;
  initialLayoutType?: LayoutType;
}

export const AdvertisingSlotComponent = forwardRef<HTMLDivElement, Props>(
  (props: Props, ref: ForwardedRef<HTMLElement>) => {
    const { categories, initialLayoutType } = props;
    const { placementId, containerId, adIndex } = useRecommendationIds({
      itemId: props.itemId,
    });

    const [recircSlotAdded, setRecircSlotAdded] = useState<boolean>(false);

    const placementsSub = useRef<() => void>();

    // Hide the parent element if the ad fails to load
    useEffect(() => {
      // Unsubscribe from previous listener if it exists
      placementsSub.current = messageBus.subscribe(
        events.PODLET.channel,
        'hide-slot-ad-container',
        (event) => {
          const hidePlacementId = event.payload;
          if ('current' in ref && hidePlacementId === placementId) {
            ref.current.style.display = 'none';
          }
        }
      );
      // Cleanup when the component unmounts or placementId changes
      return () => {
        if ('current' in placementsSub && placementsSub.current) {
          placementsSub.current();
          placementsSub.current = undefined;
        }
      };
    }, [placementId, ref]); // Add placementId to the dependency array

    useEffect(() => {
      if (!recircSlotAdded && placementId) {
        injectRecircSlotInWebComponent({
          placementId,
          containerId,
          adIndex,
          categories,
          initialLayoutType
        });
        setRecircSlotAdded(true);
      }
    }, [
      recircSlotAdded,
      placementId,
      adIndex,
      containerId,
      categories,
      initialLayoutType
    ]);

    return (
      <div id={`${placementId}--tracker`} ref={ref as any}>
        <slot name={`${placementId}--recirc-slot`} />
      </div>
    );
  }
);
